//
import { empty, screenPosition } from './utils'

const headerHeight = 145

let methods = {
  init(options) {
    const $this = $(this)

    // keep in screen, add scrollbar if needed
    $this.on('show.bs.dropdown', function() {
      const $dd = $('.dropdown-menu', this)
      const $this = $(this)
      const h = $dd.height() + 24 // padding
      const pos = screenPosition($this)
      const wh = window.innerHeight - headerHeight

      if (h > wh) {
        $dd.css('max-height', `${wh}px`)
      }

      if (pos.bottom + h + 10 > window.innerHeight) {
        const px = wh - (pos.bottom + Math.min(h, wh) + 10) + headerHeight
        $dd.css('transform', `translateY(${px}px)`)
      }
    })

    $('a', this).on('click', function() {
      methods.val.call(this, $(this).data('value'))
    })

    $('.x', this).on('click', function(e) {
      e.preventDefault()
      e.stopPropagation()

      methods.val.call(this, null)
    })

    if (!empty($this.data('value'))) {
      methods.val.call(this, $this.data('value'))
    }
  },
  val(value) {
    if (arguments.length > 0) {
      const $this = $(this)
      $this.data('value', value)
      const select = $this.closest('.sg.select')
      const allowDeselect = $(select).data('allowDeselect')

      if (empty(value)) {
        select.find('.chevron').removeClass('hidden')
        if (allowDeselect !== false) {
          select.find('.x').addClass('hidden')
          select.find('.label').html(select.data('label'))
        }
      } else {
        if (allowDeselect !== false) {
          select.find('.chevron').addClass('hidden')
          select.find('.x').removeClass('hidden')
        }
        const selectedLabel = $(`[data-value="${value}"]`, select).text()
        select.find('.label').html(selectedLabel)
      }
      const name = select.data('name')
      $this.trigger('change', { name, value })
    } else {
      const $this = $(this)
      return { name: $this.data('name'), value: $this.data('value') }
    }
  },
}

export default ($) =>
  ($.fn.sgSelect = function(methodOrOptions) {
    $.each(this, function() {
      if (methodOrOptions in methods) {
        return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1))
      } else if (typeof methodOrOptions == 'object' || !methodOrOptions) {
        return methods.init.apply(this, arguments)
      } else {
        return $.error('Method ' + methodOrOptions + ' does not exist on jQuery.sgSelect')
      }
    })
  })



// WEBPACK FOOTER //
// app/javascript/sg/js/sgSelect.js